import Authorization from "../components/hoc/Authorization";
import PageLayout from "../components/molecules/PageLayout";
import ConfigList from "../components/pages/Config/ConfigList";
import ConversationDetail from "../components/pages/Conversations/ConversationDetail";
import ConversationsList from "../components/pages/Conversations/ConversationsList";
import Dashboard from "../components/pages/Dashboard";
import FAQ from "../components/pages/FAQ";
import Forb from "../components/pages/Forb";
import Smalltalk from "../components/pages/SmallTalk";
// import Login from "../components/pages/Login";
import Strom from "../components/pages/Strom";

import RouteEnum from "../enums/RouteEnum";

const AuthRoutes = [
    { path: RouteEnum.INDEX(), element: <Dashboard /> },
    { path: RouteEnum.STROM(), element: <Strom /> },
    { path: RouteEnum.FAQ(), element: <FAQ /> },
    { path: RouteEnum.FORB(), element: <Forb /> },
    { path: RouteEnum.SMALLTALK(), element: <Smalltalk /> },
    { path: RouteEnum.KONFIGURACE(), element: <ConfigList /> },
    { path: RouteEnum.KONVERZACE(), element: <ConversationsList /> },
    { path: RouteEnum.KONVERZACE_DETAIL(), element: <ConversationDetail /> },
];

const FreeRoutes: any = [];

const Routes = [
    ...FreeRoutes.map((item: any) => ({
        ...item,
        element: (
            <PageLayout showMenu={false}>
                {item.element}
            </PageLayout>
        )
    })),
    ...AuthRoutes.map(item => ({
        ...item,
        element: (
            <Authorization>
                <PageLayout showMenu={true}>
                    {item.element}
                </PageLayout>
            </Authorization>
        )
    }))
];

export default Routes;
